/* eslint-disable no-lonely-if */
/* eslint-disable no-negated-condition */
import unregisterStudentTemplate from '../unregister-student/unregister-student.html';
import template from './deregister-card-id-validation.html';

export class DeregisterCardIdValidationCardController {
/** @ngInject */
  constructor(
    $log, $mdDialog, $state, $q, $rootScope, ProximityCardService, StudentService, AttendanceService,
    CategoryOfDepartureService
  ) {
    this.$log = $log;
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.$q = $q;
    this.ProximityCardService = ProximityCardService;
    this.StudentService = StudentService;
    this.AttendanceService = AttendanceService;
    this.CategoryOfDepartureService = CategoryOfDepartureService;
  }

  cancel() {
    this.$state.go('modules.dashboard');
    this.$mdDialog.cancel();
  }

  registerStudent() {
    this.ProximityCardService.getProximityCardStudents(this.cardId).then(students => {
      this.setStudents({students: students.ownerCardList});
      this.$state.go('modules.dashboard');
      if (students.ownerCardList.length > 1) {
        this.nextStep();
      } else if (students.ownerCardList.length === 0) {
        this.$mdDialog.hide();
        this.$mdDialog.show(
          this.$mdDialog.detailsError({
            locals: {error: {
              data: {Code: 'STUDENT_NOT_REGISTER_TO_SCHOOL_COMMON_ROOM'}
            }}
          })
        );
      } else if (!students.ownerCardList[0].studentAssignedToCardOwner.registeredBy) {
        this.$mdDialog.hide();
        this.$mdDialog.show(
          this.$mdDialog.detailsError({
            locals: {error: {
              data: {Code: 'STUDENT_IS_NOT_REGISTERED'}
            }}
          })
        );
      } else {
        if (this.$rootScope.me.employeeId === students.ownerCardList[0].studentAssignedToCardOwner.registeredBy.registeringEmployeeId || this.access.attendance) {
          this.$mdDialog.show({
            resolve: {
              attendances: () => {
                return this.AttendanceService.getRegistrations({studentId: students.ownerCardList[0].studentAssignedToCardOwner.scrStudentId}).then(response => {
                  return response;
                }).catch(error => {
                  this.$mdDialog.show(
                    this.$mdDialog.extendError({
                      locals: {error}
                    })
                  );
                });
              },
              categoriesOfDeparture: () => {
                return this.CategoryOfDepartureService.getAll().then(response => {
                  return response;
                });
              }
            },
            bindToController: true,
            controllerAs: 'ctrl',
            controller: 'UnregisterStudentController',
            locals: {
              departureCategory: students.ownerCardList[0].groupType === 5 || students.ownerCardList[0].groupType === 9 ? 3 : 1,
              comment: students.ownerCardList[0].groupType === 5 || students.ownerCardList[0].groupType === 9 ? `Odebrano przez: ${students.ownerCardList[0].firstNameCardOwner} ${students.ownerCardList[0].lastNameCardOwner}` : 'Uczeń samodzielnie opuścił świetlicę'
            },
            template: unregisterStudentTemplate,
            disableParentScroll: true,
            clickOutsideToClose: true
          }).then(() => {
            this.$rootScope.$broadcast('dashboard.config.unregister');
          });
        } else {
          this.$mdDialog.hide();
          this.$mdDialog.show(
            this.$mdDialog.detailsError({
              locals: {error: {
                data: {Code: 'NO_PERMISSION_TO_UNREGISTER_STUDENT'}
              }}
            })
          );
        }
      }
    }).catch(error => {
      this.$mdDialog.hide();
      if (error.status === 400) {
        this.$mdDialog.show(
          this.$mdDialog.detailsError({
            locals: {error: {
              data: {Code: error.Code}
            }}
          })
        );
      } else if (error.status === 404) {
        this.$mdDialog.show(
          this.$mdDialog.detailsError({
            locals: {error}
          })
        );
      } else {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      }
    });
  }
}

export const DeregisterCardIdValidation = {
  bindings: {
    nextStep: '&',
    setStudents: '&',
    cardId: '@',
    students: '=',
    access: '='
  },
  controller: DeregisterCardIdValidationCardController,
  template
};
